module.exports = __webpack_public_path__ + "img/scrapBg.afe415cb.png";